import { Box, Card, Typography } from "@mui/material";
import React from "react";
export function CreamyMushroomPasta() {
  return (
    <Card sx={{ backgroundColor: "#bbbbbb" }}>
      <Typography variant="h1">Creamy Mushroom Pasta</Typography>

      <Typography>
        <Typography variant="h3">Ingredients</Typography>2 tbsp olive oil
        <br></br>1 tbsp butter<br></br>1 onion, finely chopped<br></br>
        250g button chestnut mushroom, sliced<br></br>1 garlic clove, finely
        grated<br></br>
        100ml dry white wine<br></br>
        200ml double cream<br></br>1 lemon, zest only<br></br>
        200g parmesan (or vegetarian alternative), grated, plus extra to serve
        <br></br>
        300g tagliatelle or linguini<br></br>½ small bunch parsley, finely
        chopped<br></br>
      </Typography>

      <Typography>
        Heat the oil and butter in a medium saucepan. Fry the onion over a low
        heat for 10 mins or until softened and translucent.<br></br>
        <br></br>
        Add the mushrooms and cook for 10 mins over a medium heat. Add the
        garlic and cook for 2 mins. Add the wine and bring to a simmer, reduce
        the liquid by half.<br></br>
        <br></br>
        Add the double cream and bring to a simmer, then add the lemon zest and
        parmesan. Season with salt and plenty of black pepper.<br></br>
        <br></br>
        Meanwhile, cook the pasta following pack instructions. Reserve 100ml of
        the pasta water. Toss the pasta in the pan with the creamy sauce and
        enough of the reserved water to loosen. Stir through the parsley, divide
        into bowls and top with extra cheese, if you like.<br></br>
      </Typography>
    </Card>
  );
}
